import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit
} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';


import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from 'src/app/shared/service/authentication/login.service';
import { User } from 'src/app/shared/interfaces/user';

/** @title Responsive sidenav */
@Component({
	selector: 'app-full-layout',
	templateUrl: 'full.component.html',
	styleUrls: []
})
export class FullComponent implements OnDestroy {
	mobileQuery: MediaQueryList;

	dir = 'ltr';
	dark = false;
	minisidebar = false;
	boxed = false;
	horizontal = false;

	green = false;
	blue = false;
	danger = false;
	showHide = false;
	url = '';
	sidebarOpened = false;
	status = false;

	public showSearch = false;
	public config: PerfectScrollbarConfigInterface = {};
	// tslint:disable-next-line - Disables all
	private _mobileQueryListener: () => void;

	userLogged!: User;

	constructor(
		public router: Router,
		changeDetectorRef: ChangeDetectorRef,
		media: MediaMatcher,
		public menuItems: MenuItems,
		private cookieService: CookieService,
		private loginService: LoginService
	) {
		this.mobileQuery = media.matchMedia('(min-width: 1100px)');
		this._mobileQueryListener = () => changeDetectorRef.detectChanges();
		// tslint:disable-next-line: deprecation
		this.mobileQuery.addListener(this._mobileQueryListener);
		// this is for dark theme
		// const body = document.getElementsByTagName('body')[0];
		// body.classList.toggle('dark');

		if (this.cookieService.get('theme') === 'dark') {
			this.dark = true;
			const body = document.getElementsByTagName('body')[0];
			body.classList.toggle('dark');
		} else {
			this.dark = false;
		}
	}

	ngOnDestroy(): void {
		// tslint:disable-next-line: deprecation
		this.mobileQuery.removeListener(this._mobileQueryListener);
	}


	ngOnInit() {
		//const body = document.getElementsByTagName('body')[0];
		// body.classList.add('dark');

		this.loginService.verificaAutenticacion().subscribe({
			next: (resp) => {
				this.userLogged = resp.data;
			},
		});
	}

	clickEvent(): void {
		this.status = !this.status;
	}

	darkClick() {
		if (this.cookieService.get('theme') === '') {
			this.dark = true;
			this.cookieService.set('theme', 'dark');
		} else {
			this.dark = false;
			this.cookieService.delete('theme');
		}
		const body = document.getElementsByTagName('body')[0];
		body.classList.toggle('dark');
	}



}
